<template>
  <div>
    <div
      class="mc-fix-alert"
      v-if="
        $route.name != 'AccountPlan' &&
        isPlanExpired &&
        $route.name != 'ChangePlan' &&
        $route.name != 'PaymentMethod' &&
        $route.name != 'AccountOverview'
      "
    >
      <b-row align-v="center">
        <b-col class="pr-4 pr-md-0" v-html="message"></b-col>
        <b-col md="auto" class="ml-md-auto">
          <b-button
            variant="primary"
            size="sm"
            @click="processAction"
            class="mx-md-5 mt-2 mt-md-0"
          >
            <img
              src="@/assets/img/theme/btn-loading.svg"
              alt="load"
              class="d-inline-block"
              width="50"
              v-if="apiProcessing"
            />
            <span v-else>{{ action }}</span>
          </b-button>
        </b-col>
      </b-row>
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="closeAlert()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <fullpage-loader v-if="showLoader"></fullpage-loader>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { errorTitle } from "@/common/constants";
export default {
  components: {},
  computed: {
    ...mapState({
      currentPlan: (state) => state.payment.currentPlanDetails,
    }),
  },
  created() {
    this.$store.dispatch("payment/getCurrentPlanDetails");
    this.setCurrentPlan(this.currentPlan);
  },
  data() {
    return {
      isPlanExpired: true,
      action: "",
      message: "",
      showLoader: false,
      apiProcessing: false,
    };
  },
  watch: {
    currentPlan(data) {
      this.setCurrentPlan(data);
    },
  },
  methods: {
    closeAlert() {
      this.isPlanExpired = false;
    },
    setCurrentPlan(data) {
      this.isPlanExpired = data.planExpired;
      this.action = data.action;
      this.message = data.message;
      this.canRestart = data.canRestart;
      if (data.plan_type === 1) {
        var loginData = JSON.parse(this.$ls.get("login_data"));
        loginData.plan = 1;
        this.$ls.set("login_data", JSON.stringify(loginData));
      }
      this.$store.commit("payment/setAccountStatus", data.subscription_status);
    },
    processAction() {
      if (this.canRestart === true) {
        this.$showConfirm(
          "Resume Your Subscription",
          "Are you sure, you want to resume your subscription?",
          "confirm",
          {
            confirmButtonText: "Yes, Resume!",
            preConfirm: () => {
              this.showLoader = true;
            },
          }
        ).then((res) => {
          if (res.value) {
            this.$store
              .dispatch("payment/setRestartSubscription")
              .then((response) => {
                this.isPlanExpired = false;
                this.$store.commit("payment/setPlanExpire", false);
                setTimeout(
                  () => this.$store.dispatch("payment/getCurrentPlanDetails"),
                  3000
                );
                this.toastMessage(response.message, "success");
              })
              .catch((response) => {
                this.toastMessage(response.message, "danger");
              })
              .finally(() => {
                this.showLoader = false;
              });
          }
        });
      } else if (this.currentPlan.action === "Pay now") {
        this.apiProcessing = true;
        this.$store
          .dispatch("payment/setLastSelectedPlan")
          .then((response) => {
            this.$router.push("/payment-method");
          })
          .catch((error) => {
            this.apiProcessing = false;
            this.$showConfirm(errorTitle, error.message, "warning");
          });
      } else {
        this.$router.push("/account/plan");
      }
    },
  },
};
</script>
